<template>
  <section v-if="printView">
    <v-card v-for="(filter, index) in template" :key="index" flat>
      <v-card-title v-if="filter.tags.length > 0">
        <span class="subtitle-1">{{ filter.tags.join(", ") }}</span>
      </v-card-title>
      <v-card-text :class="{ 'dense-table': $vuetify.breakpoint.xsOnly }">
        <PreparationSlipViewerGrid
          :items="getFilteredItems(items, filter.tags)"
          hideDetails
          dense
          infinite
        ></PreparationSlipViewerGrid>
      </v-card-text>
    </v-card>
  </section>
  <section v-else>
    <v-card v-for="(filter, index) in template" :key="index" flat>
      <v-card-title v-if="filter.tags.length > 0">
        <span class="subtitle-1">{{ filter.tags.join(", ") }}</span>
      </v-card-title>
      <v-card-text :class="{ 'dense-table': $vuetify.breakpoint.xsOnly }">
        <PreparationSlipViewerGrid
          :items="getFilteredItems(items, filter.tags)"
          infinite
        ></PreparationSlipViewerGrid>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import PreparationSlipViewerGrid from "./PreparationSlipViewerGrid";
export default {
  name: "PreparationSlipViewerViewer",
  components: {
    PreparationSlipViewerGrid
  },
  props: {
    template: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    printView: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getFilteredItems(items, filter) {
      if (filter.length > 0) {
        return items.filter(
          x =>
            x.data && x.data.tags && filter.every(t => x.data.tags.includes(t))
        );
      } else {
        return items;
      }
    }
  }
};
</script>

<style></style>
